export enum PaymentStatus {
  NotPaid = 1,
  Paid = 2,
  Rejected = 3,
}
